/**
 * Plural helpers for the three site languages (mirror of siteCopyPlural() in backend/siteCopy.php).
 * Romanian: 1 profil, 2 profiluri, 20 de profiluri. Russian: профиль / профиля / профилей.
 */
export function pluralForm(count, language) {
    const n = Math.abs(parseInt(count, 10) || 0);

    if (language === "rus") {
        const mod10 = n % 10;
        const mod100 = n % 100;

        if (mod10 === 1 && mod100 !== 11) return "one";
        if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return "few";

        return "many";
    }

    if (language === "eng") {
        return n === 1 ? "one" : "few";
    }

    if (n === 1) return "one";

    const mod100 = n % 100;

    return n === 0 || (mod100 > 0 && mod100 < 20) ? "few" : "many";
}

export function formatCount(count, language) {
    const n = parseInt(count, 10) || 0;
    const separator = language === "eng" ? "," : language === "rus" ? " " : ".";

    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

export function plural(forms, count, language) {
    const template = forms?.[pluralForm(count, language)] ?? forms?.many ?? "{{count}}";

    return template.replace("{{count}}", formatCount(count, language));
}
